import React, { useContext, useEffect, useState } from 'react';
import { Tabs } from 'antd';
import { api, endpoints } from '../../api';
import { logout } from '../../store/authStore/auth.action';
import { authContext } from '../../store/authStore/AuthContext';
import { FormBlock, PagesContainerUI, TabsContainer } from '../../styles/styled';
import { UserDataResponseType } from '../../types';
import ExpertProfileComponent from '../ExpertProfilePage/components/ExpertProfileComponent';
import NewExpertPage from '../NewExpertPage';
import { ExpertChangesType, ExpertType } from '../NewExpertPage/types';

const { TabPane } = Tabs;
export const ExpertUserProfilePage = () => {
  const [currentExpertState, setCurrentExpert] = useState<ExpertType | undefined>();
  const [currentExpertChangesState, setCurrentExpertChanges] = useState<ExpertChangesType>({});
  const { dispatch } = useContext(authContext);

  async function refreshData() {
    try {
      const idResponse = await api.get<UserDataResponseType>(endpoints.getUserData());

      setCurrentExpert({
        ...idResponse.data.expert,
        expert_scientific_titles: idResponse.data.expert.expert_scientific_titles
          ? [...idResponse.data.expert.expert_scientific_titles]
          : undefined,
      });
    } catch (err) {
      dispatch(logout());
    }
  }

  useEffect(() => {
    refreshData();
    //eslint-disable-next-line
  }, []);

  return (
    <PagesContainerUI>
      <br />
      {/* <BlueLayout>профиль в табс</BlueLayout> */}
      <TabsContainer white>
        <Tabs type="card" tabBarGutter={0}>
          <TabPane tab="Профиль" key="1">
            <ExpertProfileComponent expert={currentExpertState ? currentExpertState : null} />
          </TabPane>
          <TabPane tab="Редактирование" key="2">
            <FormBlock white noBorderRadius padding="0">
              <NewExpertPage
                changesState={currentExpertChangesState}
                updateChanges={(newState: ExpertChangesType) => {
                  setCurrentExpertChanges(newState);
                }}
                refreshExpertData={refreshData}
                isFormComponent
                profileExpertForm={currentExpertState}
              />
            </FormBlock>
          </TabPane>
        </Tabs>
      </TabsContainer>
    </PagesContainerUI>
  );
};
